"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var legacy_1 = require("satcheljs/lib/legacy");
var store_1 = require("../store/store");
var getMailboxJunkEmailConfiguration_1 = require("../services/getMailboxJunkEmailConfiguration");
exports.default = legacy_1.action('initMailboxJunkEmailConfiguration')(function initMailboxJunkEmailConfiguration() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    // Always reload the junk email configuration because the user may change
                    // the configuration at any time by blocking senders of individual emails
                    _a = store_1.default;
                    return [4 /*yield*/, getMailboxJunkEmailConfiguration_1.default()];
                case 1:
                    // Always reload the junk email configuration because the user may change
                    // the configuration at any time by blocking senders of individual emails
                    _a.mailboxJunkEmailConfiguration = _b.sent();
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=initMailboxJunkEmailConfiguration.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/data/owa-junkmail-configuration/lib/actions/initMailboxJunkEmailConfiguration.js
// module id = 5023
// module chunks = 2